import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { Link } from "react-router-dom";
import Loader from "../../Shared/Loader/Loader";
import { MdStar } from "react-icons/md";

const TopReview = ({ topReview, loading, setLoading }) => {
  const {
    customerName,
    customerImg,
    serviceId,
    serviceName,
    message,
    ratings,
  } = topReview;
  console.log("topReview:", topReview);

  return (
    <div className="col-md-4 mb-5 mb-md-0 card-log p-3 rounded-4">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <div
          className="d-flex justify-content-center mb-4"
          data-aos="fade-down"
          data-aos-duration="2000"
        >
          <PhotoProvider
            speed={() => 800}
            easing={(type) =>
              type === 2
                ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                : "cubic-bezier(0.34, 1.56, 0.64, 1)"
            }
          >
            <PhotoView src={customerImg}>
              <figure>
                <LazyLoadImage
                  src={customerImg}
                  alt={customerName}
                  className="rounded-circle shadow-1-strong border p-2 card-log card-effect"
                  width="150"
                  height="150"
                  placeholderSrc={customerImg}
                  effect="blur"
                  title={customerName}
                  style={{ objectFit: "cover", cursor: "pointer" }}
                />
              </figure>
            </PhotoView>
          </PhotoProvider>
        </div>
      )}
      <h5 className="mb-3" data-aos="fade-up" data-aos-duration="2000">
        {customerName}
      </h5>
      <Link to={`/services/${serviceId}`} className="top-review">
        <h6
          className="text-primary mb-3"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          {serviceName}
        </h6>
      </Link>
      <p
        className="px-xl-3 top-review-message mx-auto mb-my-0"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <i className="fas fa-quote-left pe-2 mx-2"></i> {message}
      </p>
      <ul
        className="list-unstyled d-flex justify-content-center mb-0"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <li>
          <span className="fw-bold fs-my-0">{ratings}</span>
          <MdStar className="orange-colo fs-my-6 mb-1 orange-color mx-1" />
          Rating
        </li>
      </ul>
    </div>
  );
};

export default TopReview;
